import { render, staticRenderFns } from "./PriorityRecommendations.vue?vue&type=template&id=22f75112&"
import script from "./PriorityRecommendations.vue?vue&type=script&setup=true&lang=js&"
export * from "./PriorityRecommendations.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports